<template>
<div>
  <v-subheader class='pl-0' v-if='solo' >Please choose a profession</v-subheader>
  <v-autocomplete
    @click:clear='$emit("clear")'
    autocomplete
    v-model='selected'
    label='Select a profession'
    item-text='name'
    item-value="id"
    :return-object='returnObject'
    :items='professions'
    :solo='solo'
    clearable
    :errorMessages='errorMessages'
    :loading='req.loading' >
  </v-autocomplete>
</div>
</template>

<script>
export default {
  name: 'ProfessionPicker',
  props: {
    value: { type: Object },
    solo: { type: Boolean, default: false },
    returnObject: { type: Boolean, default: true },
    errorMessages: { type: Array, default: () => { return [] } }
  },
  data () {
    return {
      selected: null,
      req: {
        resource: 'practitioner.professions'
      }
    }
  },
  mounted () {
    this.get()
    if (this.value) {
      this.selected = this.value
    }
  },
  computed: {
    professions () {
      return this.getObjectPath(this.req, 'result', [])
    }
  },
  watch: {
    value () {
      if (this.value) { this.selected = this.value }
    },
    selected () {
      this.$emit('input', this.selected)
    }
  },
  methods: {
    get () {
      this.$request('get', this.req)
    }
  }
}
</script>

<style>

</style>
